export const AUTOMATION_ENGLISH = {
  "datox.categories.add": "Add category",
  "datox.categories.managedEmpty": "Add your first category to define what to extract. Agent-created categories will also appear here.",
  "datox.categories.useInReport": "Use in this report",
  "datox.categories.edit": "Edit category",
  "datox.categories.save": "Save category",
  "datox.categories.name": "Category name",
  "datox.categories.details": "Category details",
  "datox.categories.fieldsTitle": "Fields to extract",
  "datox.categories.fieldNumber": "Field {{number}}",
  "datox.categories.addField": "Add field",
  "datox.categories.removeField": "Remove field",
  "datox.categories.moveUp": "Move up",
  "datox.categories.moveDown": "Move down",
  "datox.categories.unit": "Unit",
  "datox.categories.allowedValues": "Allowed values (one per line)",
  "datox.categories.type.text": "Text",
  "datox.categories.type.number": "Number",
  "datox.categories.type.date": "Date",
  "datox.categories.type.boolean": "Boolean",
  "datox.categories.type.enum": "Choice",
  "datox.categories.editorHint": "Define the fields and guidance for future extractions in this period. Saved extraction results remain unchanged.",
  "datox.categories.managedDescription": "Define custom extraction categories and inspect categories applied by this workflow.",
  "datox.categories.savedDefinition": "Saved definition for future extraction",
  "datox.categories.discard": "Discard unsaved category changes?",
  "datox.categories.definitionsError": "Could not load category definitions. Refresh to try again.",
  "datox.categories.saveError": "Could not save this category. Your changes are still here; try again.",
  "datox.categories.conflict": "The period changed or a workflow run is active. Close the editor, refresh, and finish any active run before saving again.",
  "datox.categories.validation.name": "Enter a category name.",
  "datox.categories.validation.duplicateCategory": "A category with this name already exists.",
  "datox.categories.validation.limit": "A period can contain at most 100 custom categories.",
  "datox.categories.validation.fields": "Add between 1 and 200 fields.",
  "datox.categories.validation.fieldName": "Enter a name for every field.",
  "datox.categories.validation.duplicateField": "Field names must be unique within the category.",
  "datox.categories.validation.choices": "Add 1–200 allowed values, each at most 255 characters.",
  "datox.automations.manual.create": "Create automation",
  "datox.automations.manual.subtitle": "Apply a workflow to another period, upload its files, and run it when ready.",
  "datox.automations.manual.apply": "Apply workflow to a period",
  "datox.automations.manual.description": "Choose the source workflow and the target period. After applying it, upload new files in the target workflow’s Files tab and click Run.",
  "datox.automations.manual.sourceHint": "Use a workflow with saved extraction and transformation results. Its steps and output designs will be reapplied to the target period.",
  "datox.automations.manual.name": "Workflow name (optional)",
  "datox.automations.manual.target": "Target period",
  "datox.automations.manual.newPeriod": "Create a new period",
  "datox.automations.manual.periodName": "New period name",
  "datox.automations.manual.periodPlaceholder": "For example, Q2, 2026",
  "datox.automations.manual.targetHint": "Choose an existing period or create one. Source files and outputs remain in their original period.",
  "datox.automations.manual.prepare": "Apply and open target workflow",
  "datox.automations.manual.transition": "{{source}} → {{target}}",
  "datox.automations.manual.mode": "Manual",
  "datox.automations.manual.createdAt": "Created (UTC): {{time}}",
  "datox.automations.manual.empty": "No automation runs yet. Apply a workflow to a target period, upload files there, then click Run.",
  "datox.automations.manual.waitingHint": "Open the target workflow, upload files in Files, then click Run.",
  "datox.automations.manual.run": "Run automation",
  "datox.automations.manual.running": "Starting…",
  "datox.automations.manual.configure": "Choose a source workflow for this period before running.",
  "datox.automations.manual.uploadFirst": "Upload files to this period before running the workflow.",
  "datox.automations.manual.source": "Applied workflow: {{source}}",
  "datox.automations.manual.targetError": "Choose a target period different from the source period.",
  "datox.categories.applied": "Applied from the source workflow; extraction has not run yet",
  "datox.automations.title": "Automations",
  "datox.automations.workspace.subtitle": "Schedule workflow replays and monitor their runs.",
  "datox.automations.workspace.source": "Source workflow",
  "datox.automations.workspace.schedule": "Schedule",
  "datox.automations.workspace.inputs": "Inputs & instructions",
  "datox.automations.workspace.dismiss": "Dismiss",
  "datox.automations.workspace.search": "Search automations or workflows",
  "datox.automations.workspace.statusFilter": "Automation status",
  "datox.automations.workspace.allStatuses": "All statuses",
  "datox.automations.workspace.noMatches": "No automations match your filters.",
  "datox.automations.workspace.pausedHint": "Paused — scheduled runs will not start.",
  "datox.automations.workspace.notRun": "Not run yet",
  "datox.automations.workspace.runDetails": "Processing details",
  "datox.automations.run.latest": "Latest run",
  "datox.automations.navigation.label": "Workflow automation links",
  "datox.automations.navigation.project": "Browse automations for this project",
  "datox.automations.navigation.automation": "View automation: {{name}}",
  "datox.automations.navigation.latestRun": "View latest run: {{name}}",
  "datox.automations.run.open": "View run",
  "datox.automations.run.details": "Run details",
  "datox.automations.run.backToHistory": "Back to run history",
  "datox.automations.run.notFound": "This run is not available in this automation. Return to the run history to choose another run.",
  "datox.automations.run.subtitle": "Review run progress, agent responses and next steps.",
  "datox.automations.run.source": "Source: {{name}} · {{period}}",
  "datox.automations.run.target": "Target period: {{period}}",
  "datox.automations.run.agentResponse": "Agent response",
  "datox.automations.run.earlierResponses": "Earlier agent responses",
  "datox.automations.run.openChat": "View agent chat",
  "datox.automations.run.viewResults": "View workflow results",
  "datox.automations.run.chatNotStarted": "No agent conversation is available for this run yet.",
  "datox.automations.run.loadingResponse": "Loading the agent’s response…",
  "datox.automations.run.liveResponse": "Responses update while this run is active.",
  "datox.automations.run.savedResponse": "Most recent saved response",
  "datox.automations.run.noResponse": "No text response is available for this run. You can view its recorded activity in the chat.",
  "datox.automations.run.responseError": "Could not refresh the agent response. Any saved response is shown below. Try Refresh or view the agent chat.",
  "datox.automations.run.chatError": "The agent chat connection is unavailable. You can still review the saved response here.",
  "datox.automations.run.resumeHint": "Resume retries this run with its original inputs.",
  "datox.automations.run.missingOutputs": "What still needs attention",
  "datox.automations.run.savedOutputs": "Saved outputs for this run",
  "datox.automations.run.output.extractions": "Extractions",
  "datox.automations.run.output.outputs": "Calculated datasets",
  "datox.automations.run.output.reports": "Reports",
  "datox.automations.run.output.dashboards": "Dashboards",
  "datox.automations.run.issue.extraction": "Data has not been extracted for this period.",
  "datox.automations.run.issue.outputs": "Calculated output tables have not been saved.",
  "datox.automations.run.issue.reports": "Some {{format}} reports are still missing.",
  "datox.automations.run.state.files": "Waiting for files",
  "datox.automations.run.state.queued": "Queued",
  "datox.automations.run.state.running": "Running",
  "datox.automations.run.state.completed": "Completed",
  "datox.automations.run.state.cancelling": "Cancelling",
  "datox.automations.run.state.cancelled": "Cancelled",
  "datox.automations.run.state.validating": "Checking results",
  "datox.automations.run.state.attention": "Action needed",
  "datox.automations.run.state.unknown": "Status unavailable",
  "datox.automations.run.heading.files": "Add the target period’s files to get started",
  "datox.automations.run.heading.queued": "Your run is waiting to start",
  "datox.automations.run.heading.running": "The agent is working on this period",
  "datox.automations.run.heading.completed": "Your workflow results are ready",
  "datox.automations.run.heading.cancelling": "The run is stopping",
  "datox.automations.run.heading.cancelled": "This run was cancelled",
  "datox.automations.run.heading.validating": "The saved results are being checked",
  "datox.automations.run.heading.attention": "Review the agent’s response before continuing",
  "datox.automations.run.heading.unknown": "Check this run’s progress",
  "datox.automations.run.next.files": "Open the target workflow, upload its files in the Files tab, then choose Run → Automation.",
  "datox.automations.run.next.queued": "No action is needed right now. This page will update when processing starts.",
  "datox.automations.run.next.running": "Read the latest agent response below or open the chat to follow its activity. Saved results are available in the target workflow.",
  "datox.automations.run.next.completed": "Open the target workflow to review the saved data, reports and any dashboards.",
  "datox.automations.run.next.cancelling": "Wait for cancellation to finish before starting another run.",
  "datox.automations.run.next.cancelled": "Any outputs already saved remain in the target workflow. To try again, open it and choose Run → Automation.",
  "datox.automations.run.next.validating": "The agent’s work is being checked against the expected outputs. This page will update when the checks finish.",
  "datox.automations.run.next.attention": "The response below explains what the agent needs. If it requests missing files, add them in the target workflow and start a new run with Run → Automation.",
  "datox.automations.run.next.unknown": "Refresh this page or open the target workflow to check the available results.",
  "datox.automations.workspace.checking": "Checking saved workflow output…",
  "datox.automations.workspace.sourceReady": "Saved workflow output found",
  "datox.automations.workspace.sourceMissing": "Source workflow needs to run first",
  "datox.automations.workspace.sourceError": "Could not check the source workflow. Refresh and try again.",
  "datox.automations.workspace.completeSource": "Open the source workflow, complete its extraction and transformation, then check again.",
  "datox.automations.workspace.openSource": "Open source workflow",
  "datox.automations.workspace.recheck": "Check again",
  "datox.automations.workspace.kind.period": "Reporting workspace",
  "datox.automations.workspace.kind.onboarding": "Customer onboarding",
  "datox.automations.workspace.kind.risk": "Risk review",
  "datox.automations.description": "Schedule an existing workflow to run again in a new period, using its categories, extraction steps, transformations, reports and dashboards.",
  "datox.automations.new": "New automation",
  "datox.automations.edit": "Edit automation",
  "datox.automations.name": "Automation name",
  "datox.automations.project": "Project",
  "datox.automations.chooseProject": "Choose a project",
  "datox.automations.workflow": "Source workflow",
  "datox.automations.chooseWorkflow": "Choose a completed workflow",
  "datox.automations.allWorkflows": "All workflows",
  "datox.automations.active": "Enabled",
  "datox.automations.paused": "Paused",
  "datox.automations.sourceHint": "Complete the workflow once before scheduling it. Saving captures its current steps and output designs for replay.",
  "datox.automations.frequency": "Frequency",
  "datox.automations.frequency.daily": "Daily",
  "datox.automations.frequency.weekly": "Weekly",
  "datox.automations.frequency.monthly": "Monthly",
  "datox.automations.frequency.quarterly": "Quarterly",
  "datox.automations.frequency.yearly": "Yearly",
  "datox.automations.interval": "Repeat every (number of frequency units)",
  "datox.automations.startsOn": "First run date",
  "datox.automations.time": "Local run time",
  "datox.automations.timezone": "Timezone (IANA name)",
  "datox.automations.enabled": "Automation enabled",
  "datox.automations.pattern": "Current-period filename pattern",
  "datox.automations.instructions": "Additional replay instructions",
  "datox.automations.save": "Save automation",
  "datox.automations.saving": "Saving…",
  "datox.automations.cancelEdit": "Cancel",
  "datox.automations.run": "Run next occurrence now",
  "datox.automations.resume": "Resume run",
  "datox.automations.cancelRun": "Cancel run",
  "datox.automations.pause": "Pause",
  "datox.automations.enable": "Enable",
  "datox.automations.refresh": "Refresh",
  "datox.automations.open": "View runs",
  "datox.automations.openPeriod": "Open workflow period",
  "datox.automations.upload": "Upload files to this period",
  "datox.automations.nextRun": "Next run (UTC): {{date}}",
  "datox.automations.scheduleSummary": "{{frequency}} · interval {{interval}} · {{timezone}}",
  "datox.automations.history": "Automation run history",
  "datox.automations.noRuns": "No runs yet. The next occurrence creates a period automatically.",
  "datox.automations.noAutomations": "No automations yet. Choose a project and an existing workflow to create one.",
  "datox.automations.waitingHint": "The new period is ready. Upload matching files there; the automation will continue when they are available.",
  "datox.automations.error": "The automation operation failed. Review the details and try again.",
  "datox.automations.conflict": "This automation changed. Refresh it before saving or retrying.",
  "datox.automations.runtimeError": "The agent runtime or API tool-signing key is not configured for automation execution.",
  "datox.automations.status.waiting_for_files": "Waiting for files",
  "datox.automations.status.pending": "Pending",
  "datox.automations.status.running": "Running",
  "datox.automations.status.completed": "Completed",
  "datox.automations.status.failed": "Needs attention",
  "datox.automations.status.blocked": "Blocked",
  "datox.automations.status.interrupted": "Interrupted",
  "datox.automations.status.cancel_requested": "Cancelling",
  "datox.automations.status.cancelled": "Cancelled",
  "datox.automations.status.awaiting_validation": "Awaiting validation",
  "datox.categories.title": "Categories",
  "datox.categories.description": "Data categories and fields applied by this workflow's extractions.",
  "datox.categories.empty": "No extraction categories have been saved yet. The agent saves them automatically when it extracts data.",
  "datox.categories.inferred": "Inferred from the saved extraction",
  "datox.categories.planned": "Defined by the agent",
  "datox.categories.field": "Field",
  "datox.categories.fieldCount": "Fields: {{count}}",
  "datox.categories.type": "Type",
  "datox.categories.required": "Required",
  "datox.categories.guidance": "Extraction guidance",
  "datox.categories.extraction": "Source extraction",
  "datox.categories.error": "Could not load extraction categories.",
} as const
